import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';
import UserSelectModal from 'components/util/UserModal';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

/* DataGrid */
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';

/* DatePicker */
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const DispatchModal = props => {
  const agGridRef = useRef();
  
  const { closeModal } = useModal();

  const [isBeforeDate, setIsBeforeDate] = useState(false);
  const [isRegi, setIsRegi] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [worker, setWorker] = useState({
    workerId: '',
    workerName: '',
    idx: 0,
  });
  const [workers, setWorkers] = useState([{
    workerId: '',
    workerName: '',
    idx: 0,
  }]);
  const [custMstInfo, setCustMstInfo] = useState({});
  const [gridRowData, setGridRowData] = useState([]);
  const [defaultColDef, setDefaultColDef] = useState({ editable: true });
  const [colDefs] = useState([{
    field: 'fkWorkerId',
    hide: true
  }, {
    field: 'commuteSeq',
    hide: true
  }, {
    field: 'staff',
    flex: 1
  }, {
    field: 'workTime',
    flex: 1
  }, {
    field: 'startTime',
    flex: 1
  }, {
    headerName: 'Action',
    minWidth: 150,
    cellRenderer: actionCellRenderer,
    colId: 'action',
    editable: false
  }]);

  function actionCellRenderer(params) {
    return params.data.commuteSeq !== 0 || moment(props.props?.data?.item?.date).isBefore(moment(), 'day') ? null :
      <button className={'action-delete'} data-action='delete'>DELETE</button>;
  }

  useEffect(() => {
    getCustMstInfo();
    getCustScheduleInfo();
  }, []);

  const getCustMstInfo = () => {
    Server.sendGet('client/management/info', {
      custMstSeq: props.props?.data.item?.fkCustMstSeq
    }, getCustMstInfoCallback).then();
  };
  const getCustMstInfoCallback = res => {
    if (moment(res?.['resultObject'].contractEndDt).isBefore(moment(), 'day')) {
      setIsBeforeDate(false);
      setDefaultColDef({ editable: false });
    } else {
      setIsBeforeDate(!moment(props.props?.data?.item?.date).isBefore(moment(), 'day'));
      setDefaultColDef({ editable: !moment(props.props?.data?.item?.date).isBefore(moment(), 'day') });
    }

    setCustMstInfo(res?.['resultObject']);
  };
  const getCustScheduleInfo = () => {
    Server.sendGet('client/schedule/info', {
      fkCustMstSeq: props.props?.data.item?.fkCustMstSeq,
      workDay: props.props?.data?.item?.date
    }, getCustScheduleInfoCallback).then();
  };
  const getCustScheduleInfoCallback = res => {
    if (res?.['resultList'].length) {
      setIsRegi(false);
    }

    res?.['resultList'].forEach(v => {
      v.staff = v.workerName;
      v.startTime = v.inTime;
    });

    setGridRowData(res?.['resultList']);
  };
  const validation = () => {
    const scheduleDetailMsgArr = [
      'Staff required.',
      'Work Time required.',
      'Start Time required.'
    ];
    const scheduleDetailColumn = [
      'staff',
      'workTime',
      'startTime'
    ];

    const rowData = [];

    agGridRef.current['api'].forEachNode(function (node) {
      rowData.push(node.data);
    });

    if (rowData.length) {
      for (let i = 0; i < rowData.length; i++) {
        for (let j = 0; j < scheduleDetailColumn.length; j++) {
          if (Common.isEmpty(rowData[i][scheduleDetailColumn[j]])) {
            Common.errorMsg(scheduleDetailMsgArr[j]);

            return false;
          }
        }
      }
    }

    return true;
  };
  const setClientSchedule = () => {
    if (validation() && !isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to save?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            const obj = {
              fkCustMstSeq: custMstInfo.custMstSeq,
              workDay: moment(`${props.props?.data?.item?.date} 00:00:00`).format('YYYY-MM-DD HH:mm:ss'),
              custScheduleDetailDTOList: []
            };

            agGridRef.current['api'].forEachNode(function (node) {
              const minutes = parseFloat(node.data.workTime) * 60;

              node.data.inTime = `${props.props?.data?.item?.date} ${node.data.startTime}`;
              node.data.outTime = moment(node.data.inTime).add(minutes, 'minutes').format('YYYY-MM-DD HH:mm:ss');

              obj.custScheduleDetailDTOList.push(node.data);
            });

            const request = isRegi ? Server.sendPost : Server.sendPut;

            request('client/schedule', obj, setClientScheduleCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };
  const setClientScheduleCallback = () => {
    setIsSubmit(false);

    props.props.data.callback();

    Common.alertSuccess();

    closeModal();
  };
  const onDataGridAdd = () => {
    const rowData = [];

    agGridRef.current['api'].forEachNode(function (node) {
      if (Common.isEmpty(node.data.attendanceState) || node.data.attendanceState !== 'A') {
        rowData.push(node.data);
      }
    });

    if (rowData.length < custMstInfo.workCnt) {
      agGridRef.current['api'].applyTransaction({
        add: [{
          fkWorkerId: '',
          commuteSeq: 0,
          staff: '',
          workTime: '',
          startTime: '00:00:00',
        }],
      });
    } else {
      Common.errorMsg(`You have exceeded the number of registered employees.\n(${custMstInfo?.custName} / Total ${custMstInfo?.workCnt} people)`);
    }
  };
  const onChoice = res => {
    const row = agGridRef.current['api'].getDisplayedRowAtIndex(res.idx);

    if (row) {
      row.data.fkWorkerId = res.workerId;
      row.data.staff = res.workerName;

      agGridRef.current['api'].applyTransaction({ update: [row.data] });
    }

    setIsModal(state => !state);
  };
  const onModal = () => {
    setIsModal(state => !state);
  };

  return (
    <>
      {isModal && <UserSelectModal list={workers} item={worker} choice={onChoice} close={onModal} check={'one'}/>}
      <CloseBtn onClick={closeModal}/>

      <div className='modal-box'>
        <div className='inner' style={{ display: isModal ? 'none' : 'block' }}>
          <Title>
            <TitHead>
              <i/>
              <h4>{props.props?.data?.item?.date} Designation of workers</h4>
            </TitHead>
            {isBeforeDate &&
              <BtnDesc>
                <TitBtn onClick={onDataGridAdd}>
                  <Ic src='https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/add_ic.svg'/>
                  <span>ADD</span>
                </TitBtn>
              </BtnDesc>
            }
          </Title>
          <ModalForm>
            <FormIn>
              <AgGridReact
                ref={agGridRef}
                className={'dataGrid'}
                rowData={gridRowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                rowHeight={35}
                headerHeight={40}
                getRowStyle={(params) => {
                  return params.data.commuteSeq !== 0 ? { pointerEvents: 'none' } : null;
                }}
                onCellClicked={(params) => {
                  if (params.column['colId'] === 'action' && params.event.target.dataset.action) {
                    if (params.event.target.dataset.action === 'delete') {
                      params.api.applyTransaction({
                        remove: [params.node.data]
                      });
                    }
                  }

                  if (isBeforeDate && params.column['colId'] === 'staff') {
                    const rowData = [];

                    agGridRef.current['api'].forEachNode(function (node) {
                      if (node.data.fkWorkerId !== params.data.fkWorkerId) {
                        node.data.idx = node.data.rowIndex;
                        node.data.workerId = node.data.fkWorkerId;
                        node.data.workerName = node.data.staff;

                        rowData.push(node.data);
                      }
                    });

                    setWorkers(rowData);
                    setWorker({
                      workerId: params.data.fkWorkerId,
                      workerName: params.data.staff,
                      idx: params.rowIndex
                    });
                    setIsModal(true);
                  }
                }}
                onCellEditingStopped={(params) => {
                  if (params.column['colId'] === 'workTime' && !Common.isNumberAndDotOnly(params.newValue)) {
                    params.node.data.workTime = params.oldValue;
                    params.api.applyTransaction({
                      update: [params.node.data]
                    });
                  }

                  if (params.column['colId'] === 'startTime' && !Common.isTimeFormat(params.newValue)) {
                    params.node.data.startTime = params.oldValue;
                    params.api.applyTransaction({
                      update: [params.node.data]
                    });
                  }
                }}
              />
            </FormIn>
            <FormBtn $Btn>
              <Btn onClick={closeModal}>Cancel</Btn>
              {isBeforeDate && <Btn $Color onClick={setClientSchedule}>Submit</Btn>}
            </FormBtn>
          </ModalForm>
        </div>
      </div>
    </>
  );
}

const Title = styled.div`
  position: relative;
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const BtnDesc = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;
`;

const TitBtn = styled.button`
  height: 30px;
  line-height: 30px;
  padding: 0 15px;
  display: flex;
  align-items: center;
  gap: 0 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  border-radius: 5px;
  margin: auto;

  & span {
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
  }

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

const Ic = styled.img.attrs({ alt: 'Util Icon' })``;

const ModalForm = styled.div`
  margin: 20px 0;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;

  .dataGrid {
    width: 100%;
    height: 160px !important;

    .ag-header-cell, .ag-header-group-cell {
      border-bottom: 1px solid #eeeeee;
      background: #f8f8f8;
    }

    .ag-header-cell-label {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .ag-ltr .ag-cell {
      border-right-width: 1px;
      padding: 0 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #eeeeee;
    }

    .action-delete {
      padding: 0 15px;
      display: flex;
      align-items: center;
      gap: 0 5px;
      background: #ff4e4e;
      border-radius: 5px;
      margin: auto;
      color: white;
      height: 25px;
    }
  }

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 15px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(70% - 10px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default DispatchModal;